// removed by extract-text-webpack-plugin
module.exports = {"workshop":"src-components-Workshop----index-module---workshop---M4qyc","bullets":"src-components-Workshop----index-module---bullets---29tAq","contactLink":"src-components-Workshop----index-module---contactLink---2r8tf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Workshop/index.module.scss
// module id = 346
// module chunks = 152909308826437